export default "__VITE_ASSET__CRmEhFkc__"